import { CalendarDays } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useLanguage } from '../../context/LanguageContext'
import Button from '../ui/Button'
import { buildContactUrl } from '../../constants/contact'

export default function CampusTourCta({ campus }) {
  const { t } = useTranslation()
  const { isRTL } = useLanguage()

  return (
    <div className="my-10 flex justify-center sm:justify-start">
      <Button
        to={buildContactUrl({ subject: 'visit_appointment', branch: campus })}
        variant="accent"
        size="lg"
        className={isRTL ? 'flex-row-reverse' : ''}
      >
        <CalendarDays className="h-5 w-5 shrink-0" aria-hidden="true" />
        {t('campusCards.bookTour')}
      </Button>
    </div>
  )
}
